import { Container } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import { Stack } from "@mui/system";
import { DataGrid } from "@mui/x-data-grid";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { create, excelDownload, uploadFile } from "../../redux/actions/staff";
import Footer from "../common/Footer";
import Header from "../common/Header";

export default function StaffInformationRegister() {
  const columns = [
    {
      field: "fmNumber",
      headerName: "教職員番号",
      width: 142,
      editable: true,
      headerClassName: "headerColor",
      sortable: false
    },
    { field: "belongs", headerName: "所属", editable: true, width: 130, headerClassName: "headerColor", sortable: false },
    { field: "name", headerName: "氏名", editable: true, width: 180, headerClassName: "headerColor", sortable: false },
    {
      field: "password",
      headerName: "pass",
      editable: true,
      width: 200,
      headerClassName: "headerColor",
      sortable: false
    },
    {
      field: "email",
      headerName: "メールアドレス",
      editable: true,
      width: 200,
      headerClassName: "headerColor",
      sortable: false
    }
  ];

  const rows = [
    { id: "1", fmNumber: "", belongs: "", name: "", password: "", email: "" },
    { id: "2", fmNumber: "", belongs: "", name: "", password: "", email: "" },
    { id: "3", fmNumber: "", belongs: "", name: "", password: "", email: "" },
    { id: "4", fmNumber: "", belongs: "", name: "", password: "", email: "" },
    { id: "5", fmNumber: "", belongs: "", name: "", password: "", email: "" }
  ];

  const dispatch = useDispatch();
  const [gridData, setGridData] = useState(rows);

  const handleGridDataChange = params => {
    const { id, field, value } = params;
    setGridData(prevData => {
      const newData = prevData.map(row => {
        if (row.id === id) {
          return { ...row, [field]: value };
        }
        return row;
      });
      return newData;
    });
  };
  const registSubmit = async () => {
    const params = [];
    const errorMessages = [];

    for (let i = 0; i < gridData.length; i++) {
      const row = gridData[i];

      // 教職員番号が空のカラムはデータ無しとして判断する。
      if (row.fmNumber === "") {
        continue;
      }

      if (!row.email) {
        errorMessages.push(`${i + 1}行目のメールアドレスが入力されていません。`);
      }
      if (!row.password) {
        errorMessages.push(`${i + 1}行目のパスワードが入力されていません。`);
      } else {
        params.push(row);
      }
    }

    if (errorMessages.length > 0) {
      alert(errorMessages.join("\r\n"));
      return;
    }

    dispatch(create(params));
  };

  const Input = styled("input")({
    display: "none"
  });
  const [file, setFile] = useState(null);

  const handleOnChange = e => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
  };

  const uploadFileSubmit = async () => {
    if (!file) {
      alert("ファイルが選択されていません。");
      return;
    }
    const excelFile = await readFileAsBase64(file);
    const params = { excelFile, fileName: file.name };
    dispatch(uploadFile(params));
  };

  const readFileAsBase64 = file => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        resolve(reader.result.replace(/^data:.*\/.*;base64,/, ""));
      };
      reader.onerror = error => {
        reject(error);
      };
      reader.readAsDataURL(file);
    });
  };

  const handleDownload = () => {
    dispatch(excelDownload());
  };

  return (
    <Box>
      <Header />
      <Container maxWidth="xl">
        <Box
          sx={{
            marginTop: 4,
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <Typography component="h3" variant="h7" align="left">
            教職員情報登録
          </Typography>
        </Box>
        <Box
          sx={{
            margin: 2,
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <Typography component="h4" variant="h7" align="left">
            新規に教職員名簿を作成する場合はこちら
          </Typography>
        </Box>
        <Box
          sx={{
            margin: 2,
            display: "flex",
            flexDirection: "column",
            bgcolor: "#fff9c4"
          }}
        >
          <Box
            sx={{
              mt: 1,
              alignItems: "left",
              justifyContent: "left",
              paddingLeft: 2
            }}
          >
            <Typography component="h4" variant="h7" align="left">
              名簿入力
            </Typography>
          </Box>
          <Box sx={{ alignItems: "center", justifyContent: "center", m: 2 }}>
            <Container maxWidth="md">
              <div
                style={{
                  height: 330,
                  width: "100%",
                  alignItems: "center",
                  justifyContent: "center"
                }}
              >
                <DataGrid
                  sx={{
                    bgcolor: "white",
                    "& .headerColor": {
                      backgroundColor: "#ffcc80"
                    }
                  }}
                  rows={gridData}
                  columns={columns}
                  onCellEditCommit={handleGridDataChange}
                  hideFooter={true}
                />
              </div>
            </Container>
          </Box>
        </Box>
        <Container maxWidth="sm">
          <Stack sx={{}} direction="row" spacing={5} justifyContent="center" paddingBottom={2}>
            <Button type="submit" variant="contained" sx={{ bgcolor: "#82b1ff", width: "50%" }} onClick={registSubmit}>
              登録
            </Button>
          </Stack>
        </Container>
        <Box
          sx={{
            margin: 2,
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <Typography component="h4" variant="h7" align="left">
            作成済みの教職員名簿から取り込む場合はこちら
          </Typography>
        </Box>
        <Box
          sx={{
            margin: 2,
            display: "flex",
            flexDirection: "column",
            bgcolor: "#fff9c4"
          }}
        >
          <Box
            sx={{
              mt: 1,
              alignItems: "left",
              justifyContent: "left",
              paddingLeft: 2
            }}
          >
            <Typography component="h4" variant="h7" align="left">
              エクセルから取り込む
            </Typography>
            <Typography component="h6" variant="h7" align="left">
              参照ボタンからファイルを選択してください
            </Typography>
          </Box>
          <Box sx={{ alignItems: "center", justifyContent: "center", m: 2 }}>
            <Container maxWidth="md">
              <div className="App">
                <label>
                  <Input type="file" accept=".xlsx,.xls" onChange={handleOnChange} />
                  <TextField
                    sx={{ bgcolor: "#ffffff" }}
                    hiddenLabel
                    id="outlined-hidden-label-small"
                    value={file ? file.name : ""}
                    variant="outlined"
                    size="small"
                  />
                  <Button
                    component="span"
                    variant="contained"
                    size="medium"
                    sx={{ bgcolor: "#82b1ff", marginLeft: "auto", ml: 3 }}
                  >
                    参照
                  </Button>
                  <Button
                    variant="contained"
                    size="medium"
                    sx={{ bgcolor: "#82b1ff", marginLeft: "auto", ml: 3 }}
                    onClick={handleDownload}
                  >
                    サンプル
                  </Button>
                </label>
              </div>
            </Container>
          </Box>
        </Box>
        <Container maxWidth="sm">
          <Stack sx={{}} direction="row" spacing={5} justifyContent="center">
            <Button type="submit" variant="contained" sx={{ bgcolor: "#82b1ff" }} onClick={uploadFileSubmit}>
              取り込む
            </Button>
          </Stack>
        </Container>
        <Box sx={{ alignItems: "right", justifyContent: "right", m: 2, display: "flex" }}>
          <Button variant="contained" size="medium" href="/AdminMenu" sx={{ bgcolor: "#82b1ff", marginLeft: "auto" }}>
            戻る
          </Button>
        </Box>
      </Container>
      <Footer />
    </Box>
  );
}
